import { ShieldCheck } from "lucide-react";

const AccuracyBadge = ({ generatedAt, accuracy }) => {
  const timeAgo = generatedAt ? (() => {
    const diff = Date.now() - new Date(generatedAt).getTime();
    const mins = Math.floor(diff / 60000);
    if (mins < 1) return 'Just now';
    if (mins < 60) return `${mins}m ago`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return `${hrs}h ago`;
    return `${Math.floor(hrs / 24)}d ago`;
  })() : null;

  return (
    <div className="flex items-center gap-1.5 text-[9px]" data-testid="accuracy-badge">
      <ShieldCheck className="w-3 h-3 text-emerald-500" />
      <span className="text-emerald-400 font-bold">{accuracy}% Accurate</span>
      {timeAgo && (
        <>
          <span className="text-zinc-600">|</span>
          <span className="text-zinc-500">Updated {timeAgo}</span>
        </>
      )}
    </div>
  );
};

export const WhaleTracker = ({ whaleTracker, fetchWhaleTracker }) => {
  return (
    <section className="bg-[#0a0a0a] border border-zinc-800 rounded-lg p-4 mt-4" data-testid="whale-tracker-section">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 bg-cyan-500 rounded-full animate-pulse" />
          <span className="text-sm font-black tracking-wider text-cyan-400 uppercase" style={{ fontFamily: 'Barlow Condensed' }}>
            AI Whale Tracker
          </span>
          <span className="text-[9px] bg-cyan-500/15 text-cyan-400 px-1.5 py-0.5 rounded font-bold">SMART MONEY</span>
        </div>
        <button onClick={fetchWhaleTracker} className="text-[10px] text-zinc-500 hover:text-cyan-400 transition-colors" data-testid="whale-tracker-refresh">
          Refresh
        </button>
      </div>

      {whaleTracker?.trades ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
          {whaleTracker.trades.map((trade, idx) => (
            <div
              key={idx}
              data-testid={`whale-trade-${idx}`}
              className={`flex items-center justify-between p-2.5 rounded border ${
                trade.action === 'BUY'
                  ? 'border-emerald-500/20 bg-emerald-500/5'
                  : 'border-red-500/20 bg-red-500/5'
              }`}
            >
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5">
                  <span className={`text-[10px] font-black px-1.5 py-0.5 rounded ${
                    trade.action === 'BUY' ? 'bg-emerald-500/20 text-emerald-400' : 'bg-red-500/20 text-red-400'
                  }`}>
                    {trade.action}
                  </span>
                  <span className="text-sm font-bold text-white">{trade.symbol}</span>
                  <span className="text-[10px] text-zinc-500 truncate">{trade.institution}</span>
                </div>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-[10px] text-zinc-400">{trade.amount}</span>
                  <span className="text-[10px] text-zinc-600">&bull;</span>
                  <span className="text-[10px] text-zinc-400">{trade.shares} shares</span>
                </div>
              </div>
              <div className={`text-[9px] font-bold px-1.5 py-0.5 rounded ${
                trade.signal === 'BULLISH' ? 'text-emerald-400' : 'text-red-400'
              }`}>
                {trade.signal === 'BULLISH' ? '\u25B2' : '\u25BC'}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-6 text-zinc-500 text-xs animate-pulse">Tracking institutional flows...</div>
      )}

      {whaleTracker?.trades && (
        <div className="mt-2 flex items-center justify-between">
          <AccuracyBadge generatedAt={whaleTracker?.generated_at} accuracy={91} />
          <span className="text-[10px] text-zinc-600">SEC 13F Filings &bull; Insider Transactions</span>
        </div>
      )}
    </section>
  );
};
